import { createRouter, createWebHistory } from 'vue-router';
import blogService from '@/services/API/blogService';
import experienceNepalService from '@/services/API/experienceNepalService';
import researchAndWhitepapers from '@/services/API/researchAndWhitepapers';
import learninghubService from '@/services/API/learninghubService';

// Views
import HomeVue from '@/views/home/Home.vue';
import AboutVue from '@/views/about/AboutView.vue';
import ContactPage from '@/views/contact/ContactPage.vue';
import ForDevelopers from '@/views/whySmartworks/forDevelopers/ForDevelopers.vue';
import ForHiringCompanies from '@/views/whySmartworks/forHiringCompanies/ForHiringCompanies.vue';
import SmartworksCentral from '@/views/jobSeekers/smartworksCentral/SmartworksCentral.vue';
import CareVue from '@/views/care/CareVue.vue';
import CertifiedDeveloper from '@/views/jobSeekers/certifiedDevelopers/CertifiedDeveloper.vue';
import RemoteCareerProgram from '@/views/jobSeekers/jobPlacementProgram/RemoteCareerProgram.vue';
// import Career from '@/views/career/Career.vue';
// renamed to Hire a Professional
// needs file name refactoring
// import DeveloperStaffingAsAService from '@/views/service/developerStaffingAsAService/DSAAS.vue';
// import SoftwareDevelopmentAsAService from '@/views/service/softwareDevelopmentAsAService/SDAAS.vue';
import JobOpenings from '@/views/jobOpenings/JobOpenings.vue';
import JobOpening from '@/views/jobOpenings/JobOpeningsShow.vue';
import DropYourInfo from '@/views/jobApplication/JobApplication.vue';
import SubmissionVue from '@/views/jobApplication/SuccessfulSubmission.vue';
import ListEvents from '@/views/events/ListEvents.vue';
import ShowEvent from '@/views/events/ShowEvent.vue';
import ListTrainings from '@/views/trainings-and-certifications/ListTrainings.vue';
import ShowTrainings from '@/views/trainings-and-certifications/ShowTrainings.vue';
import PrivacyPolicy from '@/views/privacy-policy/PrivacyPolicy.vue';
import NotFound404 from '@/views/404/NotFound404.vue';
import CustomerBlog from '@/views/customerBlog/CustomerBlog.vue';
import CustomerVue from '@/views/customers/CustomersVue.vue';

// new service pages
import BuildAppService from '@/views/service/pages/BuildMyApp.vue';
import DesignAppService from '@/views/service/pages/DesignMyApp.vue';
import ReviewAppService from '@/views/service/pages/ReviewMyApp.vue';
import RoadmapAppService from '@/views/service/pages/RoadmapMyApp.vue';
import StaffAugumentation from '@/views/service/pages/StaffAugmentation.vue';
import AppIdentityManagement from '@/views/service/pages/IdentityManagementForMyApp.vue';

// customer's story pages
import Divacs from '@/views/customers/StoryPages/DivacsStory.vue';
import AnthropicIdentity from '@/views/customers/StoryPages/AnthropicIdentityStory.vue';
import SharpScribe from '@/views/customers/StoryPages/SharpScribeStroy.vue';

// blog pages
import BlogDetails from '@/views/resources/blogs/BlogDetails.vue';
import Blogs from '@/views/resources/blogs/Blogs.vue';
import ExperienceDetails from '@/views/resources/experienceNepal/ExperienceDetails.vue';
import ExperienceNepal from '@/views/resources/experienceNepal/ExperienceNepal.vue';
import ResearchAndWhitepapersDetails from '@/views/resources/researchAndWhitepapers/ResearchAndWhitepapersDetails.vue';
import ResearchAndWhitepapers from '@/views/resources/researchAndWhitepapers/ResearchAndWhitepapers.vue';
import LearningHub from '@/views/resources/learningHub/LearningHub.vue';
import LearningHubDetails from '@/views/resources/learningHub/LearningHubDetails.vue';
import ImpactStories from '@/views/care/ImpactStories.vue';
import StoryDetail from '@/views/care/Sections/StoryDetails.vue';
//calendly redirect
import RedirectCalendly from '@/views/calendly/RedirectCalendly.vue';

// servicePackages pages
import CustomWebMobileUxUiDesign from '@/views/servicePackages/pages/CustomWebMobileUxUiDesign.vue';
import BusinessWebsitePackage from '@/views/servicePackages/pages/BusinessWebsitePackage.vue';
import MarketingWebsitePackage from '@/views/servicePackages/pages/MarketingWebsitePackage.vue';
import PortfolioWebsitePackage from '@/views/servicePackages/pages/PortfolioWebsitePackage.vue';
import ShopifyStoreDevelopment from '@/views/servicePackages/pages/ShopifyStoreDevelopment.vue';
import ShopifyMigration from '@/views/servicePackages/pages/ShopifyMigration.vue';
import CustomEcommerceDevelopment from '@/views/servicePackages/pages/CustomEcommerceDevelopment.vue';
import StripeAndPaymentIntegration from '@/views/servicePackages/pages/StripeAndPaymentIntegration.vue';
import ApiAnd3PIntegrations from '@/views/servicePackages/pages/ApiAnd3PIntegrations.vue';
import AiCodeReviewHardening from '@/views/servicePackages/pages/AiCodeReviewHardening.vue';
import PwaConversionBasic from '@/views/servicePackages/pages/PwaConversionBasic.vue';
import PwaConversionWithDatabase from '@/views/servicePackages/pages/PwaConversionWithDatabase.vue';


const routes = [
  {
    path: '/',
    name: 'home ',
    component: HomeVue,
    meta: {
      title: 'Build Apps & Scale Teams',
      description:
        'Build your app and scale your team with DIGU. We deliver cost-effective solutions to enhance growth, productivity, and impact in Nepal.',
      keywords:
        'DIGU, professional services, build apps, scale teams, hire developers, software solutions, startups, business growth, social impact',
      og: {
        title:
          'Build Apps & Scale Your Team with DIGU | Scalable Software Solutions',
        description:
          'Build your app and scale your team with DIGU. We deliver cost-effective solutions to enhance growth, productivity, and impact in Nepal.',
        url: 'https://www.digu.one',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
      twitter: {
        title: 'Build Apps & Scale Your Team with DIGU',
        description:
          'Build your app and scale your team with DIGU. We deliver cost-effective solutions to enhance growth, productivity, and impact in Nepal.',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
    },
  },
  {
    path: '/schedule-a-meeting',
    name: 'ScheduleAMeeting',
    component: RedirectCalendly,
  },
  {
    path: '/blogs-and-insights/:id',
    name: 'blogDetails',
    component: BlogDetails,
    meta: {
      title: 'Blog Page',
    },
  },
  {
    path: '/blogs-and-insights',
    name: 'blog',
    component: Blogs,
    meta: {
      url: 'https://www.digu.one/blog-and-insights',
      title: 'Articles & Insights | Business and Technology Updates',
      description:
        'Stay updated with DIGU’s articles on business trends, technology insights, and professional development tips.',
      keywords:
        'articles, business insights, technology trends, professional growth, DIGU blog, software solutions, expert advice',
      og: {
        url: 'https://www.digu.one/blog-and-insights',
        title: 'Articles & Insights | Business and Technology Updates',
        description:
          'Stay updated with DIGU’s articles on business trends, technology insights, and professional development tips.',
        keywords:
          'articles, business insights, technology trends, professional growth, DIGU blog, software solutions, expert advice',
      },
      twitter: {
        title: 'Articles & Insights | Business and Technology Updates',
        description:
          'Stay updated with DIGU’s articles on business trends, technology insights, and professional development tips.',
      },
    },
  },
  {
    path: '/experience-nepal/:id',
    name: 'ExperienceDetails',
    component: ExperienceDetails,
    meta: {
      title: 'Blog Page',
    },
  },
  {
    path: '/experience-nepal',
    name: 'ExperienceNepal',
    component: ExperienceNepal,
    meta: {
      url: 'https://www.digu.one/experience-nepal',
      title: 'Experience Nepal with DIGU | Culture and Heritage',
      description:
        'Discover Nepal’s rich culture, heritage, and traditions through DIGU’s curated stories and experiences.',
      keywords:
        'Nepal culture, heritage, DIGU stories, explore Nepal, traditions, social impact, cultural insights',
      og: {
        url: 'https://www.digu.one/experience-nepal',
        title: 'Experience Nepal with DIGU | Culture and Heritage',
        description:
          'Discover Nepal’s rich culture, heritage, and traditions through DIGU’s curated stories and experiences.',
        keywords:
          'Nepal culture, heritage, DIGU stories, explore Nepal, traditions, social impact, cultural insights',
      },
      twitter: {
        title: 'Experience Nepal with DIGU | Culture and Heritage',
        description:
          'Discover Nepal’s rich culture, heritage, and traditions through DIGU’s curated stories and experiences.',
      },
    },
  },
  // {
  //   path: '/research-and-whitepapers/:id',
  //   name: 'ResearchAndWhitepapersDetails',
  //   component: ResearchAndWhitepapersDetails,
  //   meta: {
  //     title: 'research and whitepapers',
  //   },
  // },
  // {
  //   path: '/research-and-whitepapers',
  //   name: 'ResearchAndWhitepaper',
  //   component: ResearchAndWhitepapers,
  //   meta: {
  //     url: 'https://www.digu.one/research-and-whitepapers',
  //     title: 'Research & Whitepapers | Insights and Industry Research by DIGU',
  //     description:
  //       'Access DIGU’s collection of in-depth research and whitepapers, providing insights into technology trends, best practices, and industry advancements.',
  //     keywords:
  //       'research papers, whitepapers, technology research, industry insights, DIGU, SaaS trends, software solutions, best practices, tech innovation',
  //     og: {
  //       url: 'https://www.digu.one/research-and-whitepapers',
  //       title:
  //         'Research & Whitepapers | Insights and Industry Research by DIGU',
  //       description:
  //         'Access DIGU’s collection of in-depth research and whitepapers, providing insights into technology trends, best practices, and industry advancements.',
  //     },
  //     twitter: {
  //       title:
  //         'Research & Whitepapers | Insights and Industry Research by DIGU',
  //       description:
  //         'Access DIGU’s collection of in-depth research and whitepapers, providing insights into technology trends, best practices, and industry advancements.',
  //     },
  //   },
  // },
  {
    path: '/learning-hub/:id',
    name: 'LearningHubDetails',
    component: LearningHubDetails,
    meta: {
      title: 'Learning hub details',
    },
  },
  {
    path: '/learning-hub',
    name: 'LearningHub',
    component: LearningHub,
    meta: {
      url: 'https://www.digu.one/learning-hub',
      title: 'DIGU Learning Hub | Webinars, Masterclasses, and More',
      description:
        'Explore DIGU’s Learning Hub for recorded webinars, workshops, masterclasses, and expert-led training sessions.',
      keywords:
        'learning hub, webinars, masterclasses, workshops, training, professional development, DIGU education.',
      og: {
        url: 'https://www.digu.one/leaning-hub',
        title: 'DIGU Learning Hub | Webinars, Masterclasses, and More',
        description:
          'Explore DIGU’s Learning Hub for recorded webinars, workshops, masterclasses, and expert-led training sessions.',
        keywords:
          'learning hub, webinars, masterclasses, workshops, training, professional development, DIGU education.',
      },
      twitter: {
        title: 'DIGU Learning Hub | Webinars, Masterclasses, and More',
        description:
          'Explore DIGU’s Learning Hub for recorded webinars, workshops, masterclasses, and expert-led training sessions.',
      },
    },
  },

  {
    path: '/build-my-app',
    name: 'buildmyapp',
    component: BuildAppService,
    meta: {
      title: 'Build My App with DIGU | Robust Software Development',
      description:
        'Build scalable, high-quality apps with DIGU’s developers. From idea to launch, we deliver robust solutions to meet your goals.',
      keywords:
        'build apps, app development, scalable apps, software solutions, DIGU, hire developers, robust applications',
      og: {
        title: 'Build My App with DIGU | Robust Software Development',
        description:
          'Build scalable, high-quality apps with DIGU’s developers. From idea to launch, we deliver robust solutions to meet your goals.',
        url: 'https://www.digu.one/build-my-app',
      },
      twitter: {
        title: 'Build My App with DIGU | Robust Software Development',
        description:
          'Build scalable, high-quality apps with DIGU’s developers. From idea to launch, we deliver robust solutions to meet your goals.',
      },
    },
  },
  {
    path: '/design-my-app',
    name: 'designmyapp',
    component: DesignAppService,
    meta: {
      title: 'Design My App with DIGU | Custom App Design Services',
      description:
        'Create stunning, user-friendly app designs with DIGU’s expert design team. We craft custom designs tailored to your brand and user needs.',
      keywords:
        'app design, custom design, user experience, DIGU, UI/UX design, mobile app design, web app design',
      og: {
        title: 'Design My App with DIGU | Custom App Design Services',
        description:
          'Create stunning, user-friendly app designs with DIGU’s expert design team. We craft custom designs tailored to your brand and user needs.',
        url: 'https://www.digu.one/design-my-app',
      },
      twitter: {
        title: 'Design My App with DIGU | Custom App Design Services',
        description:
          'Create stunning, user-friendly app designs with DIGU’s expert design team. We craft custom designs tailored to your brand and user needs.',
      },
    },
  },
  {
    path: '/review-my-app',
    name: 'reviewmyapp',
    component: ReviewAppService,
    meta: {
      title: 'Review My App with DIGU | Expert Code Assessments',
      description:
        'Optimize your app with DIGU’s detailed code reviews and performance assessments to ensure quality and reliability.',
      keywords:
        'code reviews, app optimization, software quality, DIGU, application assessment, performance review, user experience',
      og: {
        title: 'Review My App with DIGU | Expert Code Assessments',
        description:
          'Optimize your app with DIGU’s detailed code reviews and performance assessments to ensure quality and reliability.',
        url: 'https://www.digu.one/review-my-app',
      },
      twitter: {
        title: 'Review My App with DIGU | Expert Code Assessments',
        description:
          'Optimize your app with DIGU’s detailed code reviews and performance assessments to ensure quality and reliability.',
      },
    },
  },
  {
    path: '/roadmap-my-app',
    name: 'roadmapmyapp',
    component: RoadmapAppService,
    meta: {
      title: 'Roadmap My App with DIGU | Strategic App Planning',
      description:
        'Plan your app’s success with DIGU’s expert roadmap services. Navigate development milestones confidently and effectively.',
      keywords:
        'app roadmap, project planning, development milestones, DIGU, software strategy, app success, startup support',
      og: {
        title: 'Roadmap My App with DIGU | Strategic App Planning',
        description:
          'Plan your app’s success with DIGU’s expert roadmap services. Navigate development milestones confidently and effectively.',
        url: 'https://www.digu.one/roadmap-my-app',
      },
      twitter: {
        title: 'Roadmap My App with DIGU | Strategic App Planning',
        description:
          'Plan your app’s success with DIGU’s expert roadmap services. Navigate development milestones confidently and effectively.',
      },
    },
  },
  {
    path: '/staff-augmentation',
    name: 'StaffAugmentation',
    component: StaffAugumentation,
    meta: {
      title: 'Staff Augmentation with DIGU | Scale Your Team',
      description:
        'Scale your business with DIGU’s staff augmentation services. Hire skilled engineers and maintain a seamless global workflow.',
      keywords:
        'staff augmentation, hire engineers, remote talent, DIGU, engineering teams, global workflow, business scaling',
      og: {
        title: 'Staff Augmentation with DIGU | Scale Your Team',
        description:
          'Scale your business with DIGU’s staff augmentation services. Hire skilled engineers and maintain a seamless global workflow.',
        url: 'https://www.digu.one/staff-augmentation',
      },
      twitter: {
        title: 'Staff Augmentation with DIGU | Scale Your Team',
        description:
          'Scale your business with DIGU’s staff augmentation services. Hire skilled engineers and maintain a seamless global workflow.',
      },
    },
  },
  {
    path: '/implement-identity-management',
    name: 'implementIdentityManagement',
    component: AppIdentityManagement,
    meta: {
      title: 'Identity Management | Okta Services by DIGU & Anthropic',
      description:
        'Transform your identity strategy with DIGU and Anthropic Identity. Access certified Okta professionals for scalable, secure solutions and seamless integration.',
      keywords:
        'identity management, Okta consulting, identity solutions, DIGU, Anthropic Identity, customer identity, secure integration, scalable solutions, certified Okta professionals, IAM services',
      og: {
        title:
          'Implement Identity Management | Okta Services by DIGU & Anthropic',
        description:
          'Transform your identity strategy with DIGU and Anthropic Identity. Access certified Okta professionals for scalable, secure solutions and seamless integration.',
        url: 'https://www.digu.one/implement-identity-management',
      },
      twitter: {
        title:
          'Implement Identity Management | Okta Services by DIGU & Anthropic',
        description:
          'Transform your identity strategy with DIGU and Anthropic Identity. Access certified Okta professionals for scalable, secure solutions and seamless integration.',
      },
    },
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutVue,
    meta: {
      title: 'About DIGU | Mission-Driven Software Solutions Provider',
      description:
        'Learn about DIGU’s mission to empower professionals, deliver world class software solutions, and support businesses globally',
      keywords:
        'about DIGU, mission-driven company, social impact, software solutions, startups, career growth, hire engineers, Nepal talent',
      og: {
        title: 'About DIGU | Mission-Driven Software Solutions Provider',
        description:
          ' Learn about DIGU’s mission to empower professionals, deliver world-class software solutions, and support businesses globally.',
        url: 'https://www.digu.one/about',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
      twitter: {
        title: 'About DIGU | Mission-Driven Software Solutions Provider',
        description:
          ' Learn about DIGU’s mission to empower professionals, deliver world-class software solutions, and support businesses globally.',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage,
    meta: {
      title: 'Contact Us',
    },
  },
  {
    path: '/for-job-seekers',
    redirect: '/why-digu-for-career-opportunities',
  },
  {
    path: '/why-smartworks-for-career-opportunities',
    redirect: '/why-digu-for-career-opportunities',
  },
  {
    path: '/why-digu-for-career-opportunities',
    name: 'WhyDIGUForCareerOpportunities',
    component: ForDevelopers,
    meta: {
      title: 'Why DIGU For Career Opportunities',
    },
  },
  {
    path: '/for-hiring-companies',
    redirect: '/why-smartworks-for-businesses',
  },
  {
    path: '/why-smartworks-for-businesses',
    redirect: '/why-digu-for-businesses',
  },
  {
    path: '/why-digu-for-businesses',
    name: 'whyDiguForBusinesses',
    component: ForHiringCompanies,
    meta: {
      title: 'Why DIGU | Scalable Solutions for Business Growth',
      description:
        'Partner with DIGU for scalable solutions, expert teams, and seamless collaboration to accelerate business growth and innovation.',
      keywords:
        'about DIGU, mission-driven company, social impact, software solutions, startups, career growth, hire engineers, Nepal talent',
      og: {
        title: ' Why DIGU | Scalable Solutions for Business Growth',
        description:
          'Partner with DIGU for scalable solutions, expert teams, and seamless collaboration to accelerate business growth and innovation.',
        url: 'https://digu.one/why-digu-for-businesses',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
      twitter: {
        title: 'Why DIGU | Scalable Solutions for Business Growth',
        description:
          'Partner with DIGU for scalable solutions, expert teams, and seamless collaboration to accelerate business growth and innovation.',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
    },
  },
  {
    path: '/learn-about-smartworks-central',
    redirect: '/smartworks-central',
  },
  {
    path: '/learn-about-digu-central',
    redirect: '/smartworks-central',
  },
  {
    path: '/smartworks-central',
    redirect: '/digu-central',
  },
  {
    path: '/digu-central',
    name: 'SmartworksCentral',
    component: SmartworksCentral,
    meta: {
      title: 'Learn About DIGU Central Office',
    },
  },
  {
    path: '/care',
    redirect: '/smartworks-cares',
  },
  {
    path: '/smartworks-cares',
    redirect: '/digu-cares',
  },
  {
    path: '/grassroot-impact-initative',
    name: 'SmartworksCares',
    component: CareVue,
    meta: {
      title: 'DIGU Cares | Impactful, Sustainable Programs in Nepal',
      description:
        'Explore DIGU Cares, supporting education, health, and economic growth in Nepal through impactful, sustainable programs.',
      keywords:
        'DIGU Cares, social impact, education support, health programs, economic growth, Nepal development, sustainability',
      og: {
        title: 'DIGU Cares | Impactful, Sustainable Programs in Nepal',
        description:
          ' Explore DIGU Cares, supporting education, health, and economic growth in Nepal through impactful, sustainable programs.',
        url: 'https://www.digu.one/digu-cares',
        image: 'https://digu.one/img/programs-section.1abee262.webp',
      },
      twitter: {
        title: 'DIGU Cares | Impactful, Sustainable Programs in Nepal',
        description:
          'Explore DIGU Cares, supporting education, health, and economic growth in Nepal through impactful, sustainable programs.',
        image: 'https://digu.one/img/programs-section.1abee262.webp',
      },
    },
  },
  {
    path: '/impact-stories',
    name: 'ImpactStories',
    component: ImpactStories,
  },
  {
    path: '/impact-story/:slug',
    name: 'StoryDetail',
    component: StoryDetail,
  },

  {
    path: '/verified-badges',
    name: 'certifiedDeveloper',
    component: CertifiedDeveloper,
    meta: {
      title: 'Verified Badges with DIGU | Showcase Your Skills',
      description:
        'Showcase your skills with DIGU’s verified badges and gain credibility with global employers.',
      keywords:
        ' verified badges, skills certification, DIGU, global job readiness, professional credibility, certifications',
      og: {
        title: 'Verified Badges with DIGU | Showcase Your Skills',
        description:
          'Showcase your skills with DIGU’s verified badges and gain credibility with global employers.',
        url: 'https://www.digu.one/verified-badges',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
      twitter: {
        title: 'Verified Badges with DIGU | Showcase Your Skills',
        description:
          'Showcase your skills with DIGU’s verified badges and gain credibility with global employers.',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
    },
  },
  {
    path: '/remote-career',
    name: 'remoteCareerProgram',
    component: RemoteCareerProgram,
    meta: {
      title: 'Remote Career Acceleration Program',
    },
  },
  // {
  //   path: '/career',
  //   redirect: '/join-our-talent-pool',
  // },
  // {
  //   path: '/join-our-talent-pool',
  //   name: 'joinOurTalentPool',
  //   component: Career,
  //   meta: {
  //     title: 'Join Our talent Pool',
  //   },
  // },
  // {
  //   path: '/job-openings',
  //   redirect: '/talents-on-demand',
  // },
  {
    path: '/talents-on-demand',
    name: 'developersOnDemand',
    component: JobOpenings,
    meta: {
      title: 'Developers On Demand',
    },
  },
  {
    path: '/job-openings/:id',
    redirect: '/talents-on-demand/:id',
  },
  {
    path: '/talents-on-demand/:id',
    name: 'developersOnDemandShow',
    component: JobOpening,
    meta: {
      title: 'Developers On Demand',
    },
  },
  {
    path: '/customers',
    name: 'customers',
    component: CustomerVue,
    meta: {
      title: 'DIGU Customer Stories | Empowering Global Businesses',
      description:
        'Discover how DIGU helps businesses achieve success with innovative solutions and exceptional engineering talent.',
      keywords:
        'customer success stories, DIGU reviews, software solutions, business impact, case studies, hire developers, client success',
      og: {
        title: 'DIGU Customer Stories | Empowering Global Businesses',
        description:
          'Discover how DIGU helps businesses achieve success with innovative solutions and exceptional engineering talent.',
        url: 'https://www.digu.one/customers',
        // image: '[Insert Image URL]'
      },
      twitter: {
        title: 'DIGU Customer Stories | Empowering Global Businesses',
        description:
          'Discover how DIGU helps businesses achieve success with innovative solutions and exceptional engineering talent.',
        // image: '[Insert Image URL]'
      },
    },
  },
  {
    path: '/divacs',
    name: 'divacs',
    component: Divacs,
    meta: {
      title: 'Digu Story',
    },
  },
  {
    path: '/anthropic-identity',
    name: 'anthropic-identity',
    component: AnthropicIdentity,
    meta: {
      title: 'Anthropic Identity Story',
    },
  },
  {
    path: '/sharp-scribe',
    name: 'sharp-scribe',
    component: SharpScribe,
    meta: {
      title: 'SharpScribe Story',
    },
  },

  {
    path: '/digu-blog',
    name: 'digu-blog',
    component: CustomerBlog,
    meta: {
      title: 'Customer Blog',
    },
  },
  {
    path: '/drop-your-info',
    name: 'dropYourInfo',
    component: DropYourInfo,
    meta: {
      title: 'Job Application',
    },
  },
  {
    path: '/successful-submission',
    name: 'successfulSubmission',
    component: SubmissionVue,
    props: (route) => ({
      applicantName: route.query.name || '',
    }),
    meta: {
      title: 'Application submission',
    },
  },
  //
  // {
  //   path: '/hire-a-professional',
  //   name: 'hireAProfessional',
  //   component: DeveloperStaffingAsAService,
  //   meta: {
  //     title: 'Hire a Professional',
  //   },
  // },
  // {
  //   path: '/software-development-as-a-service',
  //   redirect: '/outsource-your-project',
  // },
  // {
  //   path: '/outsource-your-project',
  //   name: 'outsourceYoutProject',
  //   component: SoftwareDevelopmentAsAService,
  //   meta: {
  //     title: 'Outsource Your Project',
  //   },
  // },
  {
    path: '/events',
    name: 'listEvents',
    component: ListEvents,
    meta: {
      title: 'Upcoming Events',
    },
  },
  {
    path: '/events/:slug',
    name: 'showEvent',
    component: ShowEvent,
    meta: {
      title: 'DIGU Upcoming Events | Webinars, Workshops, and More',
      description:
        'Stay updated with DIGU’s upcoming events, featuring live webinars, expert-led workshops, and networking opportunities.',
      keywords:
        'DIGU events, webinars, workshops, networking, professional growth, live sessions, training events',
      og: {
        title: 'DIGU Upcoming Events | Webinars, Workshops, and More',
        description:
          'Stay updated with DIGU’s upcoming events, featuring live webinars, expert-led workshops, and networking opportunities.',
        url: 'https://digu.one/events',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
      twitter: {
        title: 'DIGU Upcoming Events | Webinars, Workshops, and More',
        description:
          'Stay updated with DIGU’s upcoming events, featuring live webinars, expert-led workshops, and networking opportunities.',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
    },
  },
  {
    path: '/trainings-and-certifications',
    name: 'listTrainings',
    component: ListTrainings,
    meta: {
      title: 'DIGU Trainings & Certifications | Advance Your Career',
      description:
        'Advance your career with DIGU’s training and certification programs. Earn industry-recognized credentials to achieve professional growth.',
      keywords:
        'DIGU training, certifications, professional growth, skill development, career advancement, industry credentials',
      og: {
        title: 'DIGU Trainings & Certifications | Advance Your Career',
        description:
          'Advance your career with DIGU’s training and certification programs. Earn industry-recognized credentials to achieve professional growth.',
        url: 'https://digu.one/trainings-and-certifications',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
      twitter: {
        title: 'DIGU Trainings & Certifications | Advance Your Career',
        description:
          'Advance your career with DIGU’s training and certification programs. Earn industry-recognized credentials to achieve professional growth.',
        image: 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
      },
    },
  },
  {
    path: '/trainings-and-certifications/:slug',
    name: 'showTrainings',
    component: ShowTrainings,
    meta: {
      title: 'Show Training and Certification',
    },
  },

  // Service Packages
  {
    path: '/service-packages/custom-web-mobile-ux-ui-design',
    name: 'ServicePackagesCustomUxUi',
    component: CustomWebMobileUxUiDesign,
    meta: {
      title: 'Custom Web & Mobile UX/UI Design',
      description:
        'User-centered, modern, accessible UX/UI design for web and mobile. Includes a tailored design system, wireframes, and WCAG AA alignment.',
      keywords:
        'UX, UI, product design, web design, mobile design, design system, WCAG, accessibility',
      og: {
        title: 'Custom Web & Mobile UX/UI Design',
        description:
          'User-centered, modern, accessible UX/UI design for web and mobile. Includes a tailored design system, wireframes, and WCAG AA alignment.',
        url: 'https://www.digu.one/service-packages/custom-web-mobile-ux-ui-design',
      },
      twitter: {
        title: 'Custom Web & Mobile UX/UI Design',
        description:
          'User-centered, modern, accessible UX/UI design for web and mobile. Includes a tailored design system, wireframes, and WCAG AA alignment.',
      },
    },
  },
  {
    path: '/service-packages/business-website-package',
    name: 'BusinessWebsitePackage',
    component: BusinessWebsitePackage,
    meta: { title: 'Business Website Package' },
  },
  {
    path: '/service-packages/marketing-website-package',
    name: 'MarketingWebsitePackage',
    component: MarketingWebsitePackage,
    meta: { title: 'Marketing Website Package' },
  },
  {
    path: '/service-packages/portfolio-website-package',
    name: 'PortfolioWebsitePackage',
    component: PortfolioWebsitePackage,
    meta: { title: 'Portfolio Website Package' },
  },
  {
    path: '/service-packages/shopify-store-development',
    name: 'ShopifyStoreDevelopment',
    component: ShopifyStoreDevelopment,
    meta: { title: 'Shopify Store Development Package' },
  },
  {
    path: '/service-packages/shopify-migration',
    name: 'ShopifyMigration',
    component: ShopifyMigration,
    meta: { title: 'Shopify Migration Package' },
  },
  {
    path: '/service-packages/custom-ecommerce-development',
    name: 'CustomEcommerceDevelopment',
    component: CustomEcommerceDevelopment,
    meta: { title: 'Custom E-Commerce Website Development' },
  },
  {
    path: '/service-packages/stripe-and-payment-integration',
    name: 'StripeAndPaymentIntegration',
    component: StripeAndPaymentIntegration,
    meta: { title: 'Stripe & Payment Integration' },
  },
  {
    path: '/service-packages/api-and-3p-integrations',
    name: 'ApiAnd3PIntegrations',
    component: ApiAnd3PIntegrations,
    meta: { title: 'API & 3rd-Party Tool Integrations' },
  },
  {
    path: '/service-packages/ai-code-review-hardening',
    name: 'AiCodeReviewHardening',
    component: AiCodeReviewHardening,
    meta: { title: 'AI Code Review & Hardening' },
  },
  {
    path: '/service-packages/pwa-conversion-basic',
    name: 'PwaConversionBasic',
    component: PwaConversionBasic,
    meta: { title: 'Progressive Web App (PWA) Conversion — Basic' },
  },
  {
    path: '/service-packages/pwa-conversion-with-database',
    name: 'PwaConversionWithDatabase',
    component: PwaConversionWithDatabase,
    meta: { title: 'PWA Conversion with Database' },
  },

  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Privacy Policy',
    },
  },

  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound404,
    meta: {
      title: 'Not Found',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Initialize meta tags if not present
  const ensureMetaTag = (selector, attribute, value) => {
    let element = document.querySelector(selector);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, value);
      document.head.appendChild(element);
    }
    return element;
  };

  // Handle dynamic routes
  if (
    [
      'blogDetails',
      'ExperienceDetails',
      'ResearchAndWhitepapersDetails',
      'LearningHubDetails',
    ].includes(to.name)
  ) {
    try {
      let response;
      let baseUrl;
      let defaultDescription;
      let defaultKeywords;

      if (to.name === 'blogDetails') {
        response = await blogService.showBlogDetail(to.params.id);
        baseUrl = 'https://www.digu.one/blogs-and-insights';
        defaultDescription =
          'Stay updated with DIGU’s articles on business trends, technology insights, and professional development tips.';
        defaultKeywords =
          'articles, business insights, technology trends, DIGU blog';
      } else if (to.name === 'ExperienceDetails') {
        response = await experienceNepalService.showExperienceDetail(
          to.params.id
        );
        baseUrl = 'https://www.digu.one/experience-nepal';
        defaultDescription =
          'Discover Nepal’s culture, travel tips, and experiences with DIGU’s curated guides.';
        defaultKeywords =
          'Nepal culture, travel Nepal, DIGU experiences, travel guides, Nepal tourism';
      } else if (to.name === 'ResearchAndWhitepapersDetails') {
        response = await researchAndWhitepapers.showWhitepapersDetail(
          to.params.id
        );
        baseUrl = 'https://www.digu.one/research-and-whitepapers';
        defaultDescription =
          'Explore DIGU’s research and whitepapers on technology, business, and industry trends.';
        defaultKeywords =
          'research papers, whitepapers, DIGU insights, technology trends, business research';
      } else if (to.name === 'LearningHubDetails') {
        response = await learninghubService.showLearninghubDetail(to.params.id);
        baseUrl = 'https://www.digu.one/learning-hub';
        defaultDescription =
          'Access DIGU’s Learning Hub for tutorials, courses, and resources to advance your skills.';
        defaultKeywords =
          'learning hub, DIGU tutorials, skill development, online courses, professional growth';
      }

      if (response.status === 200) {
        const item = response.data;
        const url = `${baseUrl}/${item.slug}`;
        const description =
          item.metaDescription && item.metaDescription.length < 120
            ? `${item.metaDescription} - Explore more with DIGU.`
            : item.metaDescription || defaultDescription;

        // Set document title
        document.title = item.metaTitle
          ? `${item.metaTitle} | DIGU`
          : `${to.meta.title} | DIGU`;

        // Define meta tags
        const metaTags = [
          { name: 'description', content: description },
          {
            name: 'keywords',
            content: item.tags ? item.tags.join(', ') : defaultKeywords,
          },
          { property: 'og:title', content: item.metaTitle || to.meta.title },
          { property: 'og:description', content: description },
          {
            property: 'og:image',
            content:
              item.featuredImage ||
              'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
          },
          { property: 'og:url', content: url },
          { name: 'twitter:title', content: item.metaTitle || to.meta.title },
          { name: 'twitter:description', content: description },
          {
            name: 'twitter:image',
            content:
              item.featuredImage ||
              'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp',
          },
          { name: 'twitter:card', content: 'summary_large_image' },
        ];

        // Update or create meta tags
        metaTags.forEach(({ name, property, content }) => {
          const selector = name
            ? `meta[name="${name}"]`
            : `meta[property="${property}"]`;
          const attribute = name ? 'name' : 'property';
          const element = ensureMetaTag(selector, attribute, name || property);
          element.setAttribute('content', content);
        });
      } else {
        document.title = `${to.meta.title} | DIGU`;
      }
    } catch (error) {
      console.error(`Error fetching ${to.name} metadata:`, error);
      document.title = `${to.meta.title} | DIGU`;
    }
  } else {
    // Existing logic for static meta tags
    document.title = to.meta.title ? `${to.meta.title} | DIGU` : 'DIGU';

    const metaDescription = ensureMetaTag(
      'meta[name="description"]',
      'name',
      'description'
    );
    metaDescription.setAttribute('content', to.meta.description || '');

    const metaKeywords = ensureMetaTag(
      'meta[name="keywords"]',
      'name',
      'keywords'
    );
    metaKeywords.setAttribute('content', to.meta.keywords || '');

    const ogTitle = ensureMetaTag(
      'meta[property="og:title"]',
      'property',
      'og:title'
    );
    ogTitle.setAttribute('content', to.meta.og?.title || '');

    const ogDescription = ensureMetaTag(
      'meta[property="og:description"]',
      'property',
      'og:description'
    );
    ogDescription.setAttribute('content', to.meta.og?.description || '');

    const ogUrl = ensureMetaTag(
      'meta[property="og:url"]',
      'property',
      'og:url'
    );
    ogUrl.setAttribute('content', to.meta.og?.url || '');

    const ogImage = ensureMetaTag(
      'meta[property="og:image"]',
      'property',
      'og:image'
    );
    ogImage.setAttribute('content', to.meta.og?.image || '');

    const twitterTitle = ensureMetaTag(
      'meta[name="twitter:title"]',
      'name',
      'twitter:title'
    );
    twitterTitle.setAttribute('content', to.meta.twitter?.title || '');

    const twitterDescription = ensureMetaTag(
      'meta[name="twitter:description"]',
      'name',
      'twitter:description'
    );
    twitterDescription.setAttribute(
      'content',
      to.meta.twitter?.description || ''
    );

    const twitterImage = ensureMetaTag(
      'meta[name="twitter:image"]',
      'name',
      'twitter:image'
    );
    twitterImage.setAttribute('content', to.meta.twitter?.image || '');
  }

  next();
});

export default router;
